(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["automation-process-panel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-process-panel]').forEach(function (panel) {
    var pills = panel.querySelectorAll('[data-process-pill]');
    var label = panel.querySelector('[data-process-label]');
    var title = panel.querySelector('[data-process-title]');
    var body = panel.querySelector('[data-process-body]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('process-pill--active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('process-pill--active');
        pill.setAttribute('aria-pressed', 'true');

        if (label) label.textContent = 'Step ' + pill.getAttribute('data-step-number');
        if (title) title.textContent = pill.getAttribute('data-step-title');
        if (body) body.textContent = pill.getAttribute('data-step-body');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  initFaqAccordions(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initFaqAccordions(event.target);
});

function initFaqAccordions(root) {
  root.querySelectorAll('[data-faq]').forEach(function (list) {
    var items = [];

    list.querySelectorAll('.faq__item').forEach(function (details) {
      var answer = details.querySelector('.faq__answer');
      if (!answer) return;
      items.push({ details: details, answer: answer });
    });

    function collapse(entry) {
      entry.details.classList.remove('is-expanded');
      entry.answer.style.maxHeight = entry.answer.scrollHeight + 'px';
      requestAnimationFrame(function () {
        entry.answer.style.maxHeight = '0px';
      });
      entry.answer.addEventListener('transitionend', function handler(e) {
        if (e.propertyName !== 'max-height') return;
        entry.details.removeAttribute('open');
        entry.answer.removeEventListener('transitionend', handler);
      });
    }

    function expand(entry) {
      entry.details.setAttribute('open', '');
      entry.details.classList.add('is-expanded');
      entry.answer.style.maxHeight = '0px';
      requestAnimationFrame(function () {
        entry.answer.style.maxHeight = entry.answer.scrollHeight + 'px';
      });
    }

    items.forEach(function (entry) {
      if (entry.details.open) entry.details.classList.add('is-expanded');
      entry.answer.style.maxHeight = entry.details.open ? entry.answer.scrollHeight + 'px' : '0px';

      entry.details.querySelector('.faq__question').addEventListener('click', function (e) {
        e.preventDefault();
        if (entry.details.open) {
          collapse(entry);
          return;
        }
        items.forEach(function (other) {
          if (other !== entry && other.details.open) collapse(other);
        });
        expand(entry);
      });
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  var onScroll = function () {
    header.classList.toggle('is-scrolled', window.scrollY > 20);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  header.querySelectorAll('[data-header-dropdown]').forEach(function (dropdown) {
    var trigger = dropdown.querySelector('[data-dropdown-trigger]');
    var closeTimer;

    var open = function () {
      clearTimeout(closeTimer);
      dropdown.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
    };
    var scheduleClose = function () {
      closeTimer = setTimeout(function () {
        dropdown.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      }, 120);
    };

    dropdown.addEventListener('mouseenter', open);
    dropdown.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('click', function () {
      var isOpen = dropdown.getAttribute('data-open') === 'true';
      dropdown.setAttribute('data-open', isOpen ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      header.querySelectorAll('[data-header-dropdown]').forEach(function (dropdown) {
        dropdown.setAttribute('data-open', 'false');
      });
    }
  });

  var mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = header.querySelector('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = mobileMenu.getAttribute('data-open') === 'true';
      mobileMenu.setAttribute('data-open', isOpen ? 'false' : 'true');
      mobileToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  header.querySelectorAll('[data-mobile-dropdown-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var group = trigger.closest('[data-mobile-group]') || trigger.parentElement;
      var isOpen = group.getAttribute('data-open') === 'true';
      group.setAttribute('data-open', isOpen ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var hero = document.querySelector('[data-hero]');
  if (!hero) return;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-target'));
    if (isNaN(target)) return;
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1200;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var value = Math.round(target * easeOutCubic(progress));
      el.textContent = prefix + value + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }
    window.requestAnimationFrame(step);
  }

  var counters = hero.querySelectorAll('[data-count-up]');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    counters.forEach(function (el) { observer.observe(el); });
  } else {
    counters.forEach(animateCount);
  }

  var visual = hero.querySelector('[data-hero-visual]');
  var canTilt = visual
    && window.matchMedia('(pointer: fine)').matches
    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (canTilt) {
    var heroRect = null;
    var ticking = false;
    var pendingX = 0.5;
    var pendingY = 0.5;

    function applyTilt() {
      var tiltX = (pendingY - 0.5) * -8;
      var tiltY = (pendingX - 0.5) * 10;
      visual.style.transform = 'rotateX(' + tiltX + 'deg) rotateY(' + tiltY + 'deg)';
      ticking = false;
    }

    hero.addEventListener('mouseenter', function () {
      heroRect = hero.getBoundingClientRect();
    });

    hero.addEventListener('mousemove', function (e) {
      if (!heroRect) heroRect = hero.getBoundingClientRect();
      pendingX = (e.clientX - heroRect.left) / heroRect.width;
      pendingY = (e.clientY - heroRect.top) / heroRect.height;
      if (!ticking) {
        window.requestAnimationFrame(applyTilt);
        ticking = true;
      }
    });

    hero.addEventListener('mouseleave', function () {
      heroRect = null;
      visual.style.transform = 'rotateX(0deg) rotateY(0deg)';
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-article]').forEach(function (root) {
    var copyButtons = root.querySelectorAll('[data-copy-link]');
    copyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-copy-url');
        if (!url || !navigator.clipboard) return;
        navigator.clipboard.writeText(url).then(function () {
          button.setAttribute('data-copied', 'true');
          button.setAttribute('data-copied-text', button.getAttribute('data-copied-label'));
          setTimeout(function () {
            button.removeAttribute('data-copied');
          }, 1500);
        }).catch(function () {});
      });
    });

    var content = root.querySelector('[data-article-content]');
    if (!content) return;

    var iconsTemplate = root.querySelector('[data-blog-faq-icons]');

    function cloneIcon(name) {
      if (!iconsTemplate) return null;
      var wrapper = iconsTemplate.content.querySelector('[data-icon="' + name + '"]');
      var svg = wrapper ? wrapper.querySelector('svg') : null;
      return svg ? svg.cloneNode(true) : null;
    }

    content.querySelectorAll('[data-blog-faq]').forEach(function (block) {
      var itemsContainer = block.querySelector('[data-blog-faq-items]');
      if (!itemsContainer) return;

      var heading = block.querySelector('h2');
      var titleText = heading ? heading.textContent.trim() : 'Frequently Asked Questions';
      var questions = itemsContainer.querySelectorAll('[data-blog-faq-q]');
      if (!questions.length) return;

      var section = document.createElement('section');
      section.className = 'blog-faq';

      var header = document.createElement('div');
      header.className = 'blog-faq__header';

      var title = document.createElement('h2');
      title.className = 'blog-faq__title';
      title.textContent = titleText;
      header.appendChild(title);

      section.appendChild(header);

      var list = document.createElement('div');
      list.className = 'blog-faq__list';

      var items = [];

      questions.forEach(function (question, index) {
        var answer = question.nextElementSibling;
        if (!answer || !answer.hasAttribute('data-blog-faq-a')) return;

        var details = document.createElement('details');
        details.className = 'blog-faq__item';
        if (index === 0) details.setAttribute('open', '');

        var summary = document.createElement('summary');
        summary.className = 'blog-faq__question';

        var number = document.createElement('span');
        number.className = 'blog-faq__number';
        number.textContent = ('0' + (index + 1)).slice(-2);
        summary.appendChild(number);

        var questionText = document.createElement('span');
        questionText.className = 'blog-faq__question-text';
        questionText.textContent = question.textContent.trim();
        summary.appendChild(questionText);

        var chevron = document.createElement('span');
        chevron.className = 'blog-faq__chevron';
        var chevronIcon = cloneIcon('chevron');
        if (chevronIcon) chevron.appendChild(chevronIcon);
        summary.appendChild(chevron);

        details.appendChild(summary);

        var answerBody = document.createElement('div');
        answerBody.className = 'blog-faq__answer';
        answerBody.innerHTML = answer.innerHTML;
        details.appendChild(answerBody);

        list.appendChild(details);
        items.push({ details: details, answer: answerBody });
      });

      function collapse(entry) {
        entry.details.classList.remove('is-expanded');
        entry.answer.style.maxHeight = entry.answer.scrollHeight + 'px';
        requestAnimationFrame(function () {
          entry.answer.style.maxHeight = '0px';
        });
        entry.answer.addEventListener('transitionend', function handler(e) {
          if (e.propertyName !== 'max-height') return;
          entry.details.removeAttribute('open');
          entry.answer.removeEventListener('transitionend', handler);
        });
      }

      function expand(entry) {
        entry.details.setAttribute('open', '');
        entry.details.classList.add('is-expanded');
        entry.answer.style.maxHeight = '0px';
        requestAnimationFrame(function () {
          entry.answer.style.maxHeight = entry.answer.scrollHeight + 'px';
        });
      }

      section.appendChild(list);
      block.replaceWith(section);

      items.forEach(function (entry) {
        if (entry.details.open) entry.details.classList.add('is-expanded');
        entry.answer.style.maxHeight = entry.details.open ? entry.answer.scrollHeight + 'px' : '0px';

        entry.details.querySelector('.blog-faq__question').addEventListener('click', function (e) {
          e.preventDefault();
          if (entry.details.open) {
            collapse(entry);
            return;
          }
          items.forEach(function (other) {
            if (other !== entry && other.details.open) collapse(other);
          });
          expand(entry);
        });
      });
    });

    var tocAside = root.querySelector('[data-article-toc]');
    var listEl = tocAside ? tocAside.querySelector('[data-toc-list]') : null;
    if (!tocAside || !listEl) return;

    var headings = content.querySelectorAll('h2');
    if (!headings.length) {
      tocAside.style.display = 'none';
      return;
    }

    var usedIds = {};
    var entries = [];

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var base = heading.textContent.trim().toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '') || 'section';
        var id = base;
        var suffix = 1;
        while (usedIds[id]) {
          suffix += 1;
          id = base + '-' + suffix;
        }
        usedIds[id] = true;
        heading.id = id;
      } else {
        usedIds[heading.id] = true;
      }

      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.className = 'article__toc-link';
      link.textContent = heading.textContent.trim();
      link.setAttribute('data-animate', 'fade-in-up');
      link.style.animationDelay = (index * 60) + 'ms';
      listEl.appendChild(link);

      link.addEventListener('click', function (e) {
        e.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + heading.id);
      });

      entries.push({ link: link, heading: heading });
    });

    // Reveal immediately: these links didn't exist when the site's global
    // scroll-reveal observer ran at page load, so it never saw them.
    entries.forEach(function (entry) {
      entry.link.classList.add('is-visible');
    });

    var indicator = document.createElement('span');
    indicator.className = 'article__toc-indicator';
    listEl.appendChild(indicator);

    function setActive(activeLink) {
      entries.forEach(function (entry) {
        entry.link.classList.remove('is-active');
      });
      if (!activeLink) {
        indicator.style.opacity = '0';
        return;
      }
      activeLink.classList.add('is-active');
      indicator.style.top = activeLink.offsetTop + 'px';
      indicator.style.height = activeLink.offsetHeight + 'px';
      indicator.style.opacity = '1';
    }

    var observer = new IntersectionObserver(function (observerEntries) {
      observerEntries.forEach(function (observerEntry) {
        if (!observerEntry.isIntersecting) return;
        var match = entries.filter(function (entry) {
          return entry.heading === observerEntry.target;
        })[0];
        if (match) setActive(match.link);
      });
    }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });

    entries.forEach(function (entry) {
      observer.observe(entry.heading);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-blog-list]').forEach(function (root) {
    var resultsWrap = root.querySelector('[data-blog-results]');
    var tabsWrap = root.querySelector('[data-blog-filter-tabs]');
    var searchForm = root.querySelector('[data-blog-search-form]');
    var searchInput = root.querySelector('[data-blog-search-input]');
    if (!resultsWrap) return;

    var blogUrl = root.getAttribute('data-blog-url');
    var sectionId = root.getAttribute('data-section-id');
    var predictiveSearchUrl = root.getAttribute('data-predictive-search-url');

    var currentTag = '';
    var currentPage = 1;
    var observer = null;
    var cachedFilterHtml;

    function fetchFragment(url, callback) {
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          callback(new DOMParser().parseFromString(html, 'text/html'));
        })
        .catch(function () {});
    }

    // The site-wide scroll-reveal observer only ever looks at elements present
    // at initial page load (plus shopify:section:load in the theme editor), so
    // [data-animate] cards injected here via fetch would otherwise stay at
    // opacity: 0 forever. Reveal them ourselves right after inserting.
    function revealNewCards() {
      resultsWrap.querySelectorAll('[data-animate]').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    function setupObserver() {
      if (observer) observer.disconnect();
      var sentinel = resultsWrap.querySelector('[data-blog-sentinel]');
      if (!sentinel || sentinel.getAttribute('data-has-next') !== 'true') return;
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNextPage();
        });
      }, { rootMargin: '400px' });
      observer.observe(sentinel);
    }

    function buildTagUrl(tag, page) {
      var url = tag ? (blogUrl + '/tagged/' + encodeURIComponent(tag)) : blogUrl;
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
      if (page > 1) url += '&page=' + page;
      return url;
    }

    function loadTag(tag) {
      if (observer) observer.disconnect();
      currentTag = tag;
      currentPage = 1;
      if (searchInput) searchInput.value = '';

      fetchFragment(buildTagUrl(tag, 1), function (doc) {
        var newResults = doc.querySelector('[data-blog-results]');
        if (!newResults) return;
        resultsWrap.innerHTML = newResults.innerHTML;
        revealNewCards();
        cachedFilterHtml = resultsWrap.innerHTML;
        setupObserver();
      });
    }

    function loadNextPage() {
      var grid = resultsWrap.querySelector('[data-blog-filter-grid]');
      var sentinel = resultsWrap.querySelector('[data-blog-sentinel]');
      if (!grid || !sentinel) return;
      if (observer) observer.disconnect();

      var nextPage = currentPage + 1;
      fetchFragment(buildTagUrl(currentTag, nextPage), function (doc) {
        var newGrid = doc.querySelector('[data-blog-filter-grid]');
        var newSentinel = doc.querySelector('[data-blog-sentinel]');
        if (newGrid) {
          while (newGrid.firstChild) {
            grid.appendChild(newGrid.firstChild);
          }
        }
        if (newSentinel) sentinel.replaceWith(newSentinel);
        currentPage = nextPage;
        revealNewCards();
        cachedFilterHtml = resultsWrap.innerHTML;
        setupObserver();
      });
    }

    function activateTab(tag) {
      if (!tabsWrap) return;
      tabsWrap.querySelectorAll('[data-filter-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-tag') === tag);
      });
    }

    if (tabsWrap) {
      tabsWrap.querySelectorAll('[data-filter-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(tab.getAttribute('data-tag'));
          loadTag(tab.getAttribute('data-tag'));
        });
      });
    }

    var searchDebounce;
    function runSearch(query) {
      if (observer) observer.disconnect();

      if (!query) {
        resultsWrap.innerHTML = cachedFilterHtml;
        revealNewCards();
        activateTab(currentTag);
        setupObserver();
        return;
      }
      if (!predictiveSearchUrl) return;

      activateTab(null);

      var url = predictiveSearchUrl + '?q=' + encodeURIComponent(query) +
        '&section_id=predictive-search&resources[type]=article&resources[limit]=10';

      fetchFragment(url, function (doc) {
        var newResults = doc.querySelector('[data-blog-results]');
        if (!newResults) return;
        resultsWrap.innerHTML = newResults.innerHTML;
        revealNewCards();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchDebounce);
        var value = searchInput.value.trim();
        searchDebounce = setTimeout(function () { runSearch(value); }, 350);
      });
    }

    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(searchDebounce);
        runSearch(searchInput ? searchInput.value.trim() : '');
      });
    }

    cachedFilterHtml = resultsWrap.innerHTML;
    setupObserver();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImage = gallery.querySelector('.main-product__image');
    var thumbs = gallery.querySelectorAll('.main-product__thumb');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full');
        if (!fullSrc) return;
        mainImage.src = fullSrc;
        mainImage.removeAttribute('srcset');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
